import { render } from "./StudebookSectionDetail.vue?vue&type=template&id=ac8ae664"
import script from "./StudebookSectionDetail.vue?vue&type=script&lang=js"
export * from "./StudebookSectionDetail.vue?vue&type=script&lang=js"

import "./StudebookSectionDetail.vue?vue&type=style&index=0&id=ac8ae664&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__